import React, { useState, useEffect, useContext } from 'react';
import { Button, Slider, Icon, Progress, Tooltip ,message} from 'antd';
import { CheckIcon } from '../../images/svgIcons';
import { useTranslation } from 'react-i18next';
import { AppStoreContext } from '../../context/appStoreContext';
import { fetchPlanUsageDetails } from '../../utils/services/planUsage';
import moment from "moment";
import {
  Container,
  Doodle,
  SelectedPlan,
  TitleSection,
  Title,
  PlanDetail,
  UsageDetails,
  AvailableValue,
  UsedValue,
  PlanOption,
  AvailValCol,
  AccountPlanUsage,
  DocAutomationSection,
  UsageDetailsWithNotes,
  GenerateDocumentCount,
  KeyNote,
} from './styles';
import Loader from '../../components/Loader';
import { LoginContainer } from '../../components/Modals/styles';
import { USERS_PLAN_USAGE_PAGE } from './translationValues';

const NAMESPACES = ['USERS_PLAN_USAGE_PAGE'];
const PlanUsage = () => {
  const { t } = useTranslation(NAMESPACES);
  const { upgradeUserPlan, userDetails } = useContext(AppStoreContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingDetails, setIsFetchingDetails] = useState(true);
  const [usageDetails, setUsageDetails] = useState();

  useEffect(() => {
    setIsFetchingDetails(true);
    setTimeout(() => {
      setIsFetchingDetails(false);
    }, 2000);
  }, []);

  const handleButtonClick = () => {
    setIsLoading(true);
    const response = upgradeUserPlan();
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const renderUsage = (option, total, used, param = '', localize) => {
    return (
      <div style={{ display: 'flex', alignItems: 'start', width: '100%', flexDirection: 'column' }}>
        <PlanOption>
          {option}
          <span>
            {`(${t(
              USERS_PLAN_USAGE_PAGE.EACH_PLAN_TOTAL_QUOTA_TEXT.key,
              USERS_PLAN_USAGE_PAGE.EACH_PLAN_TOTAL_QUOTA_TEXT.value,
            )} - ${total === undefined ? 'unlimited' : total}`}
            {param.length > 0 && ` ${param}`}
            {`)`}
            <Tooltip
              title={
                t(
                  USERS_PLAN_USAGE_PAGE[localize].key,
                  USERS_PLAN_USAGE_PAGE[localize].value,
                )
              }
            >
              {total === used && <Icon type="warning" />}
            </Tooltip>
          </span>
        </PlanOption>
        <UsedValue>
          <Slider step={1} defaultValue={parseInt(used)} max={total} min={0} disabled />{' '}
          <AvailValCol>
            <AvailableValue>
              <p>
                {t(
                  USERS_PLAN_USAGE_PAGE.PLAN_USED_COUNT_TEXT.key,
                  USERS_PLAN_USAGE_PAGE.PLAN_USED_COUNT_TEXT.value,
                )}
              </p>
              {param === 'GB' ? (
                <p className="count">{used?.toFixed(1) + param + '/' + total + param}</p>
              ) : (
                <p className="count">{used} / {usageDetails?.upperLimit?.planName === "Premium" && total === null ? <p className='infinity-icon'>∞</p> : total}</p>
              )}
            </AvailableValue>
          </AvailValCol>
        </UsedValue>
      </div>
    );
  };

  const renderSupport = (option, param = '', isNotValue = false, isAvailable) => {
    if (isNotValue) {
      return (
        <div className="branding">
          <PlanOption>{option}</PlanOption>
          <p className="nonSliderVal">{param}</p>
          {isAvailable ? (
            <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
          ) : (
            <Icon type="close-circle" theme="twoTone" twoToneColor="red" />
          )}
        </div>
      );
    }
  };

  useEffect(() => {
    const fetchDetails = async () => {
      const result = await fetchPlanUsageDetails();
      if (result.statusCode === 1918) {
        setUsageDetails(result.data);
      }else{
        message.error(t(USERS_PLAN_USAGE_PAGE.SOMETHING_WRONG_ERROR_MESSAGE.key, USERS_PLAN_USAGE_PAGE.SOMETHING_WRONG_ERROR_MESSAGE.value));
      }
    }
    fetchDetails()

  }, []);

  return (
    <>
      {isFetchingDetails ? (
        <LoginContainer>
          <Loader />
        </LoginContainer>
      ) : (
        <Container>
          <TitleSection>
            <Doodle />
            <Title>
              <h3>
                {t(
                  USERS_PLAN_USAGE_PAGE.ACCOUNT_USAGE_TITLE.key,
                  USERS_PLAN_USAGE_PAGE.ACCOUNT_USAGE_TITLE.value,
                )}
              </h3>
              <h6>
                {t(
                  USERS_PLAN_USAGE_PAGE.ACCOUNT_USAGE_DESCRIPTION.key,
                  USERS_PLAN_USAGE_PAGE.ACCOUNT_USAGE_DESCRIPTION.value,
                )}
              </h6>
            </Title>
          </TitleSection>
          <SelectedPlan>
            <Icon component={CheckIcon} />
            <PlanDetail>
              <p className="currentPlan">{usageDetails?.upperLimit?.planName}</p>
              <span className="renewal">
                {' '}
                {t(
                  USERS_PLAN_USAGE_PAGE.NEXT_RENEWAL_DATE_TEXT.key,
                  USERS_PLAN_USAGE_PAGE.NEXT_RENEWAL_DATE_TEXT.value,
                )}{' '}
                {moment(usageDetails?.upperLimit?.expires).format('ll')}
              </span>
            </PlanDetail>

            {userDetails.roles.includes('ADMIN') ?
              <Button loading={isLoading} onClick={() => handleButtonClick()} >
                {isLoading
                  ? t(
                    USERS_PLAN_USAGE_PAGE.REDIRECTING_TO_UPGRADE_TEXT.key,
                    USERS_PLAN_USAGE_PAGE.REDIRECTING_TO_UPGRADE_TEXT.value,
                  )
                  :
                  t(
                    USERS_PLAN_USAGE_PAGE.UPGRADE_PLAN_BUTTON.key,
                    USERS_PLAN_USAGE_PAGE.UPGRADE_PLAN_BUTTON.value,
                  )
                }
              </Button>
              :
              <Tooltip title={t(
                USERS_PLAN_USAGE_PAGE.UPGRADE_PLAN_TOOLTIP.key,
                USERS_PLAN_USAGE_PAGE.UPGRADE_PLAN_TOOLTIP.value,
              )} >
                <Button disabled={!userDetails.roles.includes('ADMIN')}>
                  {isLoading
                    ? t(
                      USERS_PLAN_USAGE_PAGE.REDIRECTING_TO_UPGRADE_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.REDIRECTING_TO_UPGRADE_TEXT.value,
                    )
                    :
                    t(
                      USERS_PLAN_USAGE_PAGE.UPGRADE_PLAN_BUTTON.key,
                      USERS_PLAN_USAGE_PAGE.UPGRADE_PLAN_BUTTON.value,
                    )
                  }
                </Button>
              </Tooltip>
            }
          </SelectedPlan>
          <UsageDetailsWithNotes>
            {' '}
            <UsageDetails>
              <div className="transactions-info">
              <DocAutomationSection>
                <h4>
                  {t(
                    USERS_PLAN_USAGE_PAGE.DOCUMENT_GENERATION_SECTION_TITLE.key,
                    USERS_PLAN_USAGE_PAGE.DOCUMENT_GENERATION_SECTION_TITLE.value,
                  )}
                </h4>
                <div className="generateDocValue">
                  <Progress type="circle" percent={usageDetails?.remainingTransactionsPercentage.toString().substring(0, 4)} width={80} strokeWidth={18} />
                  <GenerateDocumentCount>
                    <p>
                      <h5>
                        {t(
                          USERS_PLAN_USAGE_PAGE.TOTAL_DOCUMENT_CAN_BE_GENERATED_TEXT.key,
                          USERS_PLAN_USAGE_PAGE.TOTAL_DOCUMENT_CAN_BE_GENERATED_TEXT.value,
                        )}
                      </h5>
                      <p>
                        <span className="pagesCount">{usageDetails?.upperLimit?.transactionLimit}</span> &nbsp;
                        {t(USERS_PLAN_USAGE_PAGE.PAGES_LABEL.key, USERS_PLAN_USAGE_PAGE.PAGES_LABEL.value)}
                      </p>
                    </p>
                    <p>
                      <h5>
                        {t(
                          USERS_PLAN_USAGE_PAGE.REMAINING_DOCUMENT_CAN_BE_GENERATED_TEXT.key,
                          USERS_PLAN_USAGE_PAGE.REMAINING_DOCUMENT_CAN_BE_GENERATED_TEXT.value,
                        )}
                      </h5>
                      <p>
                        <span className="pagesCount">{usageDetails?.remainingTransactions}</span>&nbsp;
                        {t(USERS_PLAN_USAGE_PAGE.PAGES_LABEL.key, USERS_PLAN_USAGE_PAGE.PAGES_LABEL.value)}
                      </p>
                    </p>
                  </GenerateDocumentCount>
                </div>
              </DocAutomationSection>
              <DocAutomationSection isEmail>
                <h4>
                  {t(
                    USERS_PLAN_USAGE_PAGE.EMAIL_DELIVERY_TITLE.key,
                    USERS_PLAN_USAGE_PAGE.EMAIL_DELIVERY_TITLE.value,
                  )}
                </h4>
                <div className="generateDocValue">
                  <Progress type="circle" percent={usageDetails?.remainingEmailTransactionsPercentage.toString().substring(0, 4)} width={80} strokeWidth={18} />
                  <GenerateDocumentCount>
                    <p>
                      <h5>
                        {t(
                          USERS_PLAN_USAGE_PAGE.TOTAL_DOCUMENT_CAN_BE_GENERATED_TEXT.key,
                          USERS_PLAN_USAGE_PAGE.TOTAL_DOCUMENT_CAN_BE_GENERATED_TEXT.value,
                        )}
                      </h5>
                      <p>
                        <span className="pagesCount">{usageDetails?.upperLimit?.emailTransactionLimit}</span> &nbsp;
                        {t(USERS_PLAN_USAGE_PAGE.EMAILS_LABEL.key, USERS_PLAN_USAGE_PAGE.EMAILS_LABEL.value)}
                      </p>
                    </p>
                    <p>
                      <h5>
                        {t(
                          USERS_PLAN_USAGE_PAGE.REMAINING_DOCUMENT_CAN_BE_GENERATED_TEXT.key,
                          USERS_PLAN_USAGE_PAGE.REMAINING_DOCUMENT_CAN_BE_GENERATED_TEXT.value,
                        )}
                      </h5>
                      <p>
                        <span className="pagesCount">{usageDetails?.remainingEmailTransactions}</span>&nbsp;
                        {t(USERS_PLAN_USAGE_PAGE.EMAILS_LABEL.key, USERS_PLAN_USAGE_PAGE.EMAILS_LABEL.value)}
                      </p>
                    </p>
                  </GenerateDocumentCount>
                </div>
              </DocAutomationSection>
              </div>
              <AccountPlanUsage className="usage">
                <div className="usageSection">
                  {renderUsage(
                    t(
                      USERS_PLAN_USAGE_PAGE.USERS_USED_DETAILS_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.USERS_USED_DETAILS_TEXT.value,
                    ),
                    usageDetails?.upperLimit?.user,
                    usageDetails?.usage?.userLimit,
                    '',
                    "CREATED_MAXIMUM_USERS_TOOLTIP"
                  )}
                  {renderUsage(
                    t(
                      USERS_PLAN_USAGE_PAGE.TEAMS_USED_DETAILS_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.TEAMS_USED_DETAILS_TEXT.value,
                    ),
                    usageDetails?.upperLimit?.team,
                    usageDetails?.usage?.teamLimit,
                    '',
                    "CREATED_MAXIMUM_TEAMS_TOOLTIP"
                  )}
                  {renderUsage(
                    t(
                      USERS_PLAN_USAGE_PAGE.STORAGE_USED_DETAILS_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.STORAGE_USED_DETAILS_TEXT.value,
                    ),
                    usageDetails?.upperLimit?.storage,
                    usageDetails?.usage?.storageLimit,
                    'GB',
                    'STORAGE_FULL_TOOLTIP'
                  )}
                  {renderUsage(
                    t(
                      USERS_PLAN_USAGE_PAGE.LANGUAGES_USED_DETAILS_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.LANGUAGES_USED_DETAILS_TEXT.value,
                    ),
                    usageDetails?.upperLimit?.language,
                    usageDetails?.usage?.languageLimit,
                    '',
                    "CREATED_MAXIMUM_SUPPORTED_LANGUAGE_TOOLTIP"
                  )}
                </div>
                <div className="usageSection">
                  {renderUsage(
                    t(USERS_PLAN_USAGE_PAGE.DOCUMENT_OR_EMAIL_CREATION_LABEL.key, USERS_PLAN_USAGE_PAGE.DOCUMENT_OR_EMAIL_CREATION_LABEL.value),
                    usageDetails?.upperLimit?.templateLimit,
                    usageDetails?.usage?.templateLimit,
                    t(USERS_PLAN_USAGE_PAGE.TEMPLATES_LABEL.key, USERS_PLAN_USAGE_PAGE.TEMPLATES_LABEL.value),
                    "TEMPLATE_CREATION_TOOLTIP"
                  )}
                  {renderUsage(
                    t(
                      USERS_PLAN_USAGE_PAGE.TEXT_GENERATION_USED_COUNT_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.TEXT_GENERATION_USED_COUNT_TEXT.value,
                    ),
                    usageDetails?.upperLimit?.textGeneration,
                    usageDetails?.usage?.textGenerationLimit,
                    'Tokens',
                    "CREATED_MAXIMUM_TEXT_GENERATION_TOOLTIP"
                  )}
                  {renderUsage(
                    t(
                      USERS_PLAN_USAGE_PAGE.TRANSLATION_USED_COUNT_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.TRANSLATION_USED_COUNT_TEXT.value,
                    ),
                    usageDetails?.upperLimit?.languageCharacter,
                    usageDetails?.usage?.languageCharacterLimit,
                    'Characters',
                    "CREATED_MAXIMUM_TRANSLATION_TOOLTIP"
                  )}
                  {renderSupport(
                    t(
                      USERS_PLAN_USAGE_PAGE.BRANDING_INFORMATION_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.BRANDING_INFORMATION_TEXT.value,
                    ),
                    usageDetails?.upperLimit?.planName === 'Free' ? t(
                      USERS_PLAN_USAGE_PAGE.BRANDING_DISPLAY_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.BRANDING_DISPLAY_TEXT.value,
                    ) : t(
                      USERS_PLAN_USAGE_PAGE.BRANDING_REMOVED_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.BRANDING_REMOVED_TEXT.value,
                    ),
                    true,
                    usageDetails?.upperLimit?.planName === 'Free' ? false : true,
                  )}
                  {renderSupport(
                    t(
                      USERS_PLAN_USAGE_PAGE.SUPPORT_INFORMATION_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.SUPPORT_INFORMATION_TEXT.value,
                    ),
                    usageDetails?.upperLimit?.planName === 'Free' ? t(
                      USERS_PLAN_USAGE_PAGE.SUPPORT_NOT_AVAILABLE_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.SUPPORT_NOT_AVAILABLE_TEXT.value,
                    ) : t(
                      USERS_PLAN_USAGE_PAGE.SUPPORT_AVAILABLE_TEXT.key,
                      USERS_PLAN_USAGE_PAGE.SUPPORT_AVAILABLE_TEXT.value,
                    ),
                    true,
                    usageDetails?.upperLimit?.planName === 'Free' ? false : true,
                  )}
                </div>
              </AccountPlanUsage>
            </UsageDetails>
            <KeyNote>
              <span>*** </span>
              {t(
                USERS_PLAN_USAGE_PAGE.PLAN_USAGE_RENEWAL_KEY_NOTE_TEXT.key,
                USERS_PLAN_USAGE_PAGE.PLAN_USAGE_RENEWAL_KEY_NOTE_TEXT.value,
              )}
            </KeyNote>
          </UsageDetailsWithNotes>
        </Container>
      )}
    </>
  );
};
export default PlanUsage;
